export default __webpack_public_path__ + "45909dee52bce70ac7b75cf4982947fd.svg";